import { render, staticRenderFns } from "./YouTubePlayer.vue?vue&type=template&id=3bdbacb5&"
import script from "./YouTubePlayer.vue?vue&type=script&lang=js&"
export * from "./YouTubePlayer.vue?vue&type=script&lang=js&"
import style0 from "./YouTubePlayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports